<app-donut-chart
  [series]="series"
  [loading]="isLoading"
  [title]="'Event Split'"
  [translateLabels]="true"
></app-donut-chart>
